import { isSameBoard } from "../boardNames";
import type { MainBoardSuggestionSource, SuggestMainBoard } from "./types";

export const suggestMainBoard: SuggestMainBoard = ({
  roles,
  sourceQuestions = [],
  boardNames,
  powerCircuitCountByBoard,
}) => {
  const onPlan = (wanted: string | null | undefined): string | null => {
    if (!wanted?.trim()) return null;
    return (
      boardNames.find((name) => isSameBoard({ board: wanted, name, label: name })) ?? null
    );
  };
  const pick = (wanted: string | null | undefined, from: MainBoardSuggestionSource) => {
    const name = onPlan(wanted);
    return name ? { name, from } : null;
  };

  const main = roles?.main;
  const decidedByNote = Boolean(main && roles?.decided_by?.[main] === "note");
  const questionPick = sourceQuestions.find(
    (question) => question.kind === "main_board_unknown" && typeof question.suggested === "string",
  )?.suggested;

  const busiest = Object.entries(powerCircuitCountByBoard)
    .filter(([, count]) => count > 0)
    .sort(([a, countA], [b, countB]) => countB - countA || a.localeCompare(b))[0]?.[0];

  return (
    pick(main, decidedByNote ? "note" : "agentRole") ??
    pick(typeof questionPick === "string" ? questionPick : null, "agentQuestion") ??
    pick(roles?.schedule_board, "schematic") ??
    pick(busiest, "appBusiest")
  );
};
